export const CAT_GRADIENTS = {
    coffee: 'linear-gradient(145deg, #78350f, #451a03)',
    walk: 'linear-gradient(145deg, #065f46, #022c22)',
    trips: 'linear-gradient(145deg, #164e63, #0c4a6e)',
    games: 'linear-gradient(145deg, #92400e, #78350f)',
    evening: 'linear-gradient(145deg, #4c1d95, #1e1b4b)',
    active: 'linear-gradient(145deg, #065f46, #022c22)',
    culture: 'linear-gradient(145deg, #701a75, #4a044e)',
    cowork: 'linear-gradient(145deg, #374151, #1f2937)',
    help: 'linear-gradient(145deg, #14532d, #052e16)',
};
export const CAT_COLORS = {
    coffee: '#f59e0b',
    walk: '#34d399',
    trips: '#22d3ee',
    games: '#fbbf24',
    evening: '#a78bfa',
    active: '#34d399',
    culture: '#f472b6',
    cowork: '#9ca3af',
    help: '#4ade80',
};
export const CAT_LABELS = {
    coffee: 'Кофе',
    walk: 'Погулять',
    trips: 'Поездки',
    games: 'Игры',
    evening: 'Вечер',
    active: 'Активности',
    culture: 'Культура',
    cowork: 'Коворк',
    help: 'Помощь',
};
export const CAT_ICONS = {
    coffee: 'coffee',
    walk: 'footprints',
    trips: 'car',
    games: 'dices',
    evening: 'beer',
    active: 'mountain',
    culture: 'ticket',
    cowork: 'briefcase',
    help: 'handshake',
};
export const CAT_DATA_COLORS = {
    coffee: '160,100,40',
    trips: '40,140,180',
    games: '200,130,40',
    evening: '120,70,200',
    active: '40,170,110',
    walk: '40,170,110',
    culture: '180,60,180',
    cowork: '110,120,140',
    help: '50,170,80',
};
export const CARD_STYLE_BG = {
    matte: (gradient) => `repeating-conic-gradient(rgba(0,0,0,.15) 0% 25%, transparent 0% 50%) 0 0 / 3px 3px, ${gradient}`,
    glossy: (gradient) => `linear-gradient(135deg, rgba(255,255,255,.22) 0%, transparent 40%, rgba(255,255,255,.1) 80%, rgba(255,255,255,.18) 100%), ${gradient}`,
    textured: (gradient) => `repeating-conic-gradient(rgba(255,255,255,.06) 0% 25%, transparent 0% 50%) 0 0 / 4px 4px, repeating-conic-gradient(rgba(0,0,0,.12) 0% 25%, transparent 0% 50%) 2px 2px / 4px 4px, ${gradient}`,
};
